export const contentDict = {
  title: "Shape Reconstruction Metrics in 3D",                // Display name
  finishDate: new Date("2023-08-21"),     // format is YYYY-MM-DD
  description: 
    `Brief guide on existing loss functions for 3D reconstructions and their weaknesses (IoU, Chamfer, Hausdorff, EMD, etc.).`,
  tags: ["ML", "Computer Vision", "3D"],
  authors: ["Philipp Wulff"],
  coverImage: require('./output_1_1.png'),
  markdownFile: require('./post.md'),
  parentDirName: "3d_metrics",    
  citations: null,
  hidden: false,
};

export default contentDict;